
import CandidateList from "./CandidateList";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";

const ArrivalCandidates = () =>{

    const navigate = useNavigate();
    const { arrivalId } = useParams()
    const [
      arrivalNotifications,
      allFiletypes,
      setUpdateData,
      setShowCandidate,
      camps
    ] = useOutletContext()
    const candidates = arrivalNotifications?.filter((arrival)=>arrival.id==arrivalId)[0]?.candidate;
    return (
      <>
        <button className="btn btn-sm md:btn-md sm:btn-sm lg:btn-md  font-bold bg-white text-black hover:bg-slate-400"
          onClick={()=>
            {
              navigate('/dashboard/arrival-notification')
              setShowCandidate({})
            }
          }
          >Go Back <BiArrowBack/></button>
        <CandidateList
          candidates={candidates}
          allFiletypes={allFiletypes}
          camps={camps}
          arrivalId={arrivalId}
          setUpdateData={setUpdateData}
          titles={[
            "Sno",
            "Select",
            "Name",
            "Nationality",
            "Visa Number",
            "Passport Number",
            "Border Number",
            "Job Position",
            "D.O.B",
            "Age",
            "Blood Group",
            "Remark",
            "Arrival Status",
            "Camp",
            "Google Map Link",
            "Action",
          ]}
        />
      </>
    );
}

export default ArrivalCandidates;